export default "__VITE_ASSET__741b130e__"